export function getRegExpCase(expression: string, caseInsensitive: boolean): RegExp {
    try {
        if (expression.indexOf('*') < 0 && expression.indexOf('?') < 0) {
            expression = `*${expression}*`;
        }
        let tmp = expression.split('*');
        let pattern = tmp.join('[\\s|\\S]*');
        tmp = pattern.split('?');
        pattern = tmp.join('[\\s|\\S]');
        return caseInsensitive ? new RegExp(`^(${pattern})$`, 'i') : new RegExp(`^(${pattern})$`);
    } catch (e) {
        console.log(e);
    }
}

export function getRegExp(expression: string): RegExp {
    return getRegExpCase(expression, false);
}

export function getStringFromRegExp(regex: RegExp): string {
    let results: string[] = regex.source.split('[\\s|\\S]*');
    let result: string = results.join('*');
    results = result.split('[\\s|\\S]');
    result = results.join('?');
    result = result.substring(
        result.indexOf('^(') + 2, 
        result.indexOf(')$')
    );
    return result;
}